<template>
  <div>
    <!--기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :options="[
        { type: 'date', label: '점검일' },
        { type: 'text', label: '점검장소' },
      ]"
      :is-print="isPrint"
    />

<!--    구분-->
    <vs-row class="mt-6 mb-4">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i> 구분</h5>
      </vs-col>
    </vs-row>
    <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
      <div class="col-span-4 flex items-center">
        <template v-if="isPrint">
          <div class="item-box-check" v-if="form.checked === '상반기'" style="text-align: center;  align-self: center;">
            <vs-icon icon="check" size="small"  ></vs-icon>
          </div>
          <div v-else class="item-box-check">
          </div>
          상반기
        </template>
        <vs-checkbox
          v-else
          class="item-box-check"
          :checked="form.checked === '상반기'"
          @change="checkForm($event, '상반기')"
        >상반기</vs-checkbox>
      </div>

      <div class="col-span-4 flex items-center">
        <template v-if="isPrint">
          <div class="item-box-check" v-if="form.checked === '하반기'" style="text-align: center;  align-self: center;">
            <vs-icon icon="check" size="small"  ></vs-icon>
          </div>
          <div v-else class="item-box-check">
          </div>
          하반기
        </template>
        <vs-checkbox
          v-else
          class="item-box-check"
          :checked="form.checked === '하반기'"
          @change="checkForm($event, '하반기')"
        >하반기</vs-checkbox>
      </div>
    </div>

    <table-place-of-business
      class="mt-5"
      :list="form.pobList"
      @updateList="updateList"
      :isPrint="isPrint"
      :isReadonly="board.readonly"
    />

    <!--    반기별 점검-->
    <table-inspect
      class="mt-5"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      :title="form.inspectionTitle"
      :list="form.inspectList"
      :is-note="true"
      :is-not-dot-in-label="true"
      :table-header-title="'점검사항'"
      :table-header-yes="'이행'"
      :table-header-no="'미이행'"
      :table-header-na="'해당없음'"
      :table-header-note="'비고'"
      @update-list-check="updateListCheck"
    />
<!--    추가-->
    <div style="background-color: #F9F9F9; padding: 10px ;border: 1px solid #cdcdcd; border-top: none;">
      <b>8. 관리감독자 업무수행 평가</b>
    </div>
    <div class="grid" style="border: 1px solid #cdcdcd; border-top: none;"
         :style="`grid-template-columns: 1fr 130px 130px 130px 388px;`">
      <div class="flexinput" style="align-items: center; padding: 10px;">
        직책:
        <p v-if="isPrint" class="ml-2 mr-2 print-input">{{ form.inputG_1 }}</p>
        <vs-input v-else class="ml-2 mr-2" type="text" v-model="form.inputG_1" :readonly="board.readonly"/>

        성명:
        <p v-if="isPrint" class="ml-2 mr-2 print-input">{{ form.inputG_2 }}</p>
        <vs-input v-else class="ml-2 mr-2" type="text" v-model="form.inputG_2" :readonly="board.readonly"/>

        점수:
        <p v-if="isPrint" class="ml-2 mr-2 print-input">{{ form.inputG_3 }}</p>
        <vs-input v-else class="ml-2 mr-2" type="text" v-model="form.inputG_3" :readonly="board.readonly"/>
      </div>

      <div class="item-box">
        <template v-if="isPrint">
          <div class="item-box-check" v-if="form.inputG_4 === 'Yes'" style="text-align: center;  align-self: center;">
            <vs-icon icon="check" size="small"  ></vs-icon>
          </div>
          <div v-else class="item-box-check">
          </div>
        </template>
        <vs-checkbox
          v-else
          class="item-box-check"
          :disabled="board.readonly"
          :checked="form.inputG_4 === 'Yes'"
          style="margin-right: 0;padding-left: 5px;"
          @change="checkInputG_4('Yes')"
        ></vs-checkbox>
      </div>
      <div class="item-box">
        <template v-if="isPrint">
          <div class="item-box-check" v-if="form.inputG_4 === 'No'" style="text-align: center;  align-self: center;">
            <vs-icon icon="check" size="small"  ></vs-icon>
          </div>
          <div v-else class="item-box-check">
          </div>
        </template>
        <vs-checkbox
          v-else
          class="item-box-check"
          :disabled="board.readonly"
          :checked="form.inputG_4 === 'No'"
          style="margin-right: 0;padding-left: 5px;"
          @change="checkInputG_4('No')"
        ></vs-checkbox>
      </div>
      <div class="item-box">
        <template v-if="isPrint">
          <div class="item-box-check" v-if="form.inputG_4 === 'N/A'" style="text-align: center;  align-self: center;">
            <vs-icon icon="check" size="small"  ></vs-icon>
          </div>
          <div v-else class="item-box-check">
          </div>
        </template>
        <vs-checkbox
          v-else
          class="item-box-check"
          :disabled="board.readonly"
          :checked="form.inputG_4 === 'N/A'"
          style="margin-right: 0;padding-left: 5px;"
          @change="checkInputG_4('N/A')"
        ></vs-checkbox>
      </div>

      <div style="border-left: 1px solid #cdcdcd; display: inline-flex; align-items: center; padding-left: 5px; padding-right: 5px;">
        <span v-if="isPrint" class="print-input"> {{form.inputG_5}} </span>
        <ml-input v-else class="w-full flex-1" v-model="form.inputG_5" :readonly="board.readonly"/>
      </div>
    </div>


    <!--    사진대지-->
    <PhotoUploadGridModule
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList"
      section-title="사진대지"
      placeholder="00센터 신축현장 점검"
      :is-print="isPrint"
      :readonly="board.readonly"
    />

    <file-upload-module
      :readonly="board.readonly"
      v-if="!isPrint"
      class="mt-component-form w-full"
      v-model="form.fileList"
    />
  </div>
</template>

<script>
import PopupPlanProject from '@/views/project/popup/PopupPlanProject'
import DateSelector from '@/components/selector/DateSelector'
import PopupProjectSetting from '@/views/project/PopupProjectSetting'
import MemberSelector from '@/components/selector/MemberSelector'
import CompanySelector from '@/components/selector/CompanySelector'
import FileUploader from '@/components/FileUploader'
import DisasterClassSelector from '@/components/selector/DisasterClassSelector'
import TableEquipment from '@/components/TableEquipment'
import TableInspect from '@/components/TableInspect'
import FileUploadModule from '@/views/modules/FileUploadModule'
import FieldSelectModule from '@/views/modules/FieldSelectModule'
import PhotoUploadGridModule from '@/views/modules/PhotoUploadGridModule'
import TablePlaceOfBusiness from '@/components/TablePlaceOfBusiness'

export default {
  components: {
    TablePlaceOfBusiness,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
    DisasterClassSelector,
    TableEquipment,
    TableInspect,
    FileUploadModule,
    FieldSelectModule,
    PhotoUploadGridModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler (value) {
        const keys = Object.keys(this.form)
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key]
          }
        }

        this.form.inspectionTitle = this.inspectionTitle
        if (!this.form || !this.form.inspectList || this.form.inspectList.length === 0) {
          this.form.inspectList = this.inspectTable
        }
      }
    },
    form: {
      immediate: true,
      deep: true,
      handler (value) {
        this.$emit('input', value)
      },
    },
  },
  data () {
    return {
      inspectionTitle: '반기별 점검',
      form: {
        inspectionTitle:'반기별 점검',
        stdInfo: {},
        photoList: [],
        checked: "",

        pobList: [],
        inspectList: [],
        fileList: [],

        inputG_1: '',
        inputG_2: '',
        inputG_3: '',
        inputG_4: '',
        inputG_5: '',
      },
    }
  },
  computed: {
    inspectTable () {
      return [
        {
          id: 1,
          label: '가. 정기 위험성평가 실시',
          is_checked: '',
          title: '1. 유해·위험요인 확인·개선',
          subtitle: '① 유해·위험요인 조사 실시 여부',
          titleColor: '#F9F9F9',
          note: '실시일:'
        },
        {
          id: 2,
          label: '나. 수시 위험성평가 실시',
          is_checked: '',
          title: '1. 유해·위험요인 확인·개선',
          note: '실시일:'
        },
        {
          id: 3,
          label: '② \'①결과\'에 따른 유해·위험요인 개선 여부',
          is_checked: '',
          title: '1. 유해·위험요인 확인·개선',
        },
        {
          id: 4,
          label: '① 안전·보건 관련 예산 편성 및 집행',
          is_checked: '',
          title: '2. 재해예방에 필요한 예산의 편성 및 집행',
          titleColor: '#F9F9F9',
          note: '편성액 : 　　　/ 집행액 : '
        },
        {
          id: 5,
          label: '① 종사자 의견 청취 절차 마련 여부',
          is_checked: '',
          title: '3. 종사자 안전·보건 의견 청취 절차 마련 및 개선',
          titleColor: '#F9F9F9',
          note: '의견청취 방법 : '
        },
        {
          id: 6,
          label: '② 의견청취 결과 개선이 필요한 경우, 방안마련 후 이행',
          is_checked: '',
          title: '3. 종사자 안전·보건 의견 청취 절차 마련 및 개선',
          titleColor: '#F9F9F9',
        },
        {
          id: 7,
          label: '① 매뉴얼마련(게시) 및 이행 조치 여부',
          is_checked: '',
          title: '4. 중대산업재해 발생 시 매뉴얼 마련 및 조치',
          titleColor: '#F9F9F9',
        },
        {
          id: 8,
          label: '② 매뉴얼 교육(공유) 실시 여부',
          is_checked: '',
          title: '4. 중대산업재해 발생 시 매뉴얼 마련 및 조치',
          titleColor: '#F9F9F9',
          note: '전직원 교육실시일 : '
        },
        {
          id: 9,
          label: '① 안전보건 수준 평가 기준·절차에 따른 적격수급인 선정 여부(안전보건관리계획서 징구 등)',
          is_checked: '',
          title: '5. 도급·용역·위탁안전·보건 확보',
          titleColor: '#F9F9F9',
        },
        {
          id: 10,
          label: '① 산업재해 조사표제출',
          is_checked: '',
          title: '6. 안전·보건 관계법령에 따른 의무이행(안전·보건 관계 법령 의무 이행 점검 결과에 따라 미이행 사항에 대한 개선 조치 여부)',
          titleColor: '#F9F9F9',
          note: '제출일 : '
        },
        {
          id: 11,
          label: '② 법령요지 게시',
          is_checked: '',
          title: '6. 안전·보건 관계법령에 따른 의무이행(안전·보건 관계 법령 의무 이행 점검 결과에 따라 미이행 사항에 대한 개선 조치 여부)',
        },
        {
          id: 12,
          label: '③ 안전표지 부착',
          is_checked: '',
          title: '6. 안전·보건 관계법령에 따른 의무이행(안전·보건 관계 법령 의무 이행 점검 결과에 따라 미이행 사항에 대한 개선 조치 여부)',
        },
        {
          id: 13,
          label: '④ 유해위험기계 등에 대한 방호, 안전조치',
          is_checked: '',
          title: '6. 안전·보건 관계법령에 따른 의무이행(안전·보건 관계 법령 의무 이행 점검 결과에 따라 미이행 사항에 대한 개선 조치 여부)',
        },
        {
          id: 14,
          label: '⑤ MSDS게시 및 경고표지 부착',
          is_checked: '',
          title: '6. 안전·보건 관계법령에 따른 의무이행(안전·보건 관계 법령 의무 이행 점검 결과에 따라 미이행 사항에 대한 개선 조치 여부)',
        },
        {
          id: 15,
          label: '⑥ 건강진단',
          is_checked: '',
          title: '6. 안전·보건 관계법령에 따른 의무이행(안전·보건 관계 법령 의무 이행 점검 결과에 따라 미이행 사항에 대한 개선 조치 여부)',
        },
        {
          id: 16,
          label: '⑦ 근골격계부담작업 유해요인조사',
          is_checked: '',
          title: '6. 안전·보건 관계법령에 따른 의무이행(안전·보건 관계 법령 의무 이행 점검 결과에 따라 미이행 사항에 대한 개선 조치 여부)',
          note: '실시일 : '
        },
        {
          id: 17,
          label: '⑧ 안전방호조치(통로확보 등)',
          is_checked: '',
          title: '6. 안전·보건 관계법령에 따른 의무이행(안전·보건 관계 법령 의무 이행 점검 결과에 따라 미이행 사항에 대한 개선 조치 여부)',
        },
        {
          id: 18,
          label: '① 안전보건교육 실시 여부(관리감독자 16시간, 현업업무종사자 24시간)',
          is_checked: '',
          title: '7. 안전·보건교육 실시(안전·보건 관계 법령에 따른 안전보건 교육 실시 여부)',
          titleColor: '#F9F9F9',
        },
      ]
    },
  },
  methods: {
    updateList (list) {
      this.form.pobList = list
    },
    updateListCheck (indexRows, text) {
      this.form.inspectList[indexRows].is_checked = text
    },
    checkForm (value, text) {
      this.form.checked = text
    },
    checkInputG_4 (value) {
      this.form.inputG_4 = value
    },
  },
}
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
.mt-component-form {
  margin-top: 15px;
}
.upload-content {
  border: $border;
  &:last-child {
    border-left: none;
  }
  &__file {
    width: 100%;
    padding: 14px;
    height: 416px;
  }
  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.item-box {
  border-left: $border;
  //border-right: $border;
  display: flex;
  .item-box-check {
    flex: 1;
    justify-content: center !important;
  }
  .item-box-check:nth-child(2) {
    border-left: $border;
    border-right: $border;
  }
}
.item-box:last-child {
  border-right: $border;
}

@media (min-width: 2000px) {
  .flexinput{
    display: flex;
  }
}
</style>
